import { Box } from "@mui/material";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import ShopitemzPrivacyEngPage from "./pages/shopitemz/ShopitemzPrivacyEngPage";
import ShopitemzPrivacyFrPage from "./pages/shopitemz/ShopitemzPrivacyFrPage";
import ZenellaPrivacyEngPage from "./pages/zenella/ZenellaPrivacyEngPage";
import ZenellaPrivacyFrPage from "./pages/zenella/ZenellaPrivacyFrPage";
import BlocNotesPrivacyEngPage from "./pages/blocnote/BlocNotesPrivacyEngPage";
import ShopitemzAccountDeletion from "./pages/shopitemz/ShopitemzAccountDeletion";
import ZenellaAccountDeletion from "./pages/zenella/ZenellaAccountDeletion";
import UDSMapPrivacyEngPage from "./pages/udsmap/UDSMapPrivacyEngPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/shopitemz-privacy-policy"
          element={<ShopitemzPrivacyEngPage />}
        />
        <Route
          path="/shopitemz-privacy-policy-fr"
          element={<ShopitemzPrivacyFrPage />}
        />
        <Route
          path="/shopitemz-delete-my-account"
          element={<ShopitemzAccountDeletion />}
        />
        <Route
          path="/zenella-privacy-policy"
          element={<ZenellaPrivacyEngPage />}
        />
        <Route
          path="/zenella-privacy-policy-fr"
          element={<ZenellaPrivacyFrPage />}
        />
        <Route
          path="/zenella-delete-my-account"
          element={<ZenellaAccountDeletion />}
        />
        <Route
          path="/blocnote-privacy-policy"
          element={<BlocNotesPrivacyEngPage />}
        />
        <Route
          path="/udsmap-privacy-policy"
          element={<UDSMapPrivacyEngPage />}
        />
      </Routes>
    </Router>
  );
}

export default App;
